var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.collaborators.length > 0
        ? _c("custom-cascader", {
            attrs: {
              multiple: "",
              placeholder: _vm.placeholder,
              options: _vm.collaborators
            },
            on: { input: _vm.selectCollaborator },
            model: {
              value: _vm.selected,
              callback: function($$v) {
                _vm.selected = $$v
              },
              expression: "selected"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }